"use client";
import { motion } from "framer-motion";
import IconBox from "@/components/icon-box";
import SectionTitle from "./section-title";
import { useTranslations } from "next-intl";

const fadeInAnimationVariants = {
  initial: {
    opacity: 0,
    y: 60,
  },
  animate: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.05 * index,
    },
  }),
};

const SectionIconBoxesLayout3 = ({ noTitle }: { noTitle?: boolean }) => {
  const t = useTranslations("SectionIconBoxes"); // Namespace SectionIconBoxes

  // Ambil data box menggunakan kunci dinamis
  const iconBoxes = Array.from({ length: 6 }).map((_, index) => ({
    title: t(`box${index + 1}.title`),
    description: t(`box${index + 1}.description`),
    icon: `/icons/icon-boxes-layout/icon-${index + 1}.svg`, // Sesuaikan path icon jika berbeda
  }));

  return (
    <section className="pb-10 pt-16 lg:pb-20 lg:pt-24">
      <div className="container">
        {!noTitle && (
          <SectionTitle
            subtitle={t("subtitle")}
            sectionClasses="mx-auto max-w-xl text-center mb-12"
            titleClasses="mb-3 text-center"
            subtitleClasses="text-md font-medium"
          >
            {t("title")}
          </SectionTitle>
        )}

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-10">
          {iconBoxes.map((iconBox, index) => (
            <motion.div
              key={index}
              variants={fadeInAnimationVariants}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              transition={{
                delay: 0.5,
              }}
              custom={index}
            >
              <IconBox
                iconBox={iconBox}
                className="py-7 text-center shadow-none before:hidden"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionIconBoxesLayout3;

